import axios from 'axios';
import { loadJS } from './general';

export const init = () => { // eslint-disable-line import/prefer-default-export
  initPhotoGallery();
};

const initPhotoGallery = () => {
  const photoGalleries = [...document.querySelectorAll('[v65jsphotogalleryid]')];
  if (photoGalleries.length) {
    loadJS('https://template-cdn.vintools.co/canyon/assets/js/vendor/ideal-image-slider.min.js', () => {
      photoGalleries.map(gallery => vtScriptPhotoGallery(gallery));
    });
  }
};

const vtScriptPhotoGallery = (photoGallery, options) => { // eslint-disable-line no-param-reassign
  const gallery = photoGallery;
  const defaults = {
    galleryId: gallery.getAttribute('v65jsphotogalleryid'),
    timestamp: `&timestamp=${new Date().getTime()}`,
    height: 'auto',
    initialHeight: 400,
    maxHeight: null,
    interval: 4000,
    transitionDuration: 700,
    effect: 'slide',
    disableNav: false,
    keyboardNav: true,
  };

  const settings = Object.assign({}, defaults, options);

  gallery.innerHTML = '';
  axios.get(`/index.cfm?method=pages.showPhotoGalleryXML&photogalleryid=${settings.galleryId}${defaults.timestamp}`, {
    responseType: 'text',
  })
    .then((response) => {
      const xml = new DOMParser().parseFromString(response.data, 'text/xml');
      return [...xml.getElementsByTagName('img')];
    })
    .then(images => images.map((image, index) => {
      const basePath = '/assets/images/photogallery/images/large/';
      const imageSrc = basePath + image.getAttribute('src');
      const link = image.getAttribute('link');
      const alt = image.getAttribute('caption') || image.getAttribute('title');
      let src = '';

      if (index !== 0) {
        src = `data-src="${imageSrc}" src=""`;
      } else {
        src = `src="${imageSrc}"`;
      }

      if (link) {
        return `<a href="${link}"><img ${src} alt="${alt}" /></a>`;
      }
      return `<img ${src} alt="${alt}" />`;
    }))
    .then((galleryImages) => {
      gallery.innerHTML = galleryImages.join('');

      const slider = new IdealImageSlider.Slider({ // eslint-disable-line no-new, no-undef, max-len
        selector: `[v65jsphotogalleryid="${settings.galleryId}"]`,
        height: settings.height,
        initialHeight: settings.initialHeight,
        maxHeight: settings.maxHeight,
        interval: settings.interval,
        transitionDuration: settings.transitionDuration,
        effect: settings.effect,
        disableNav: settings.disableNav,
        keyboardNav: settings.keyboardNav,
      });
      slider.addBulletNav();
      slider.start();
    })
    .catch(() => {
      gallery.innerHTML = '<p>Sorry, there was an error loading the gallery</p>';
    });
};



// WEBPACK FOOTER //
// ./src/assets/js/photoGallery.js